import React from 'react';
import {
  AreaChart, Area, BarChart, Bar, LineChart, Line, ComposedChart,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Cell, ReferenceLine, ReferenceArea, Legend
} from "recharts";
import {
  RouteIcon, TrendingUp, Users, Activity, Crosshair, Sparkles,
  Trophy, ClipboardList, NotebookPen, Plus, Pencil, Trash2,
  ChevronDown, ChevronUp, Search, ArrowUpRight, ArrowDownRight,
  Download, Calendar, Clock, CheckCircle2, XCircle, AlertTriangle,
  Info, Zap, Brain, BarChart3, X, UserCheck, Building2,
  HeartHandshake, CalendarDays, CalendarCheck, Stethoscope,
  FlaskConical, Headphones, Receipt, Smartphone, Globe,
  HeartPulse, MessageSquare, ShoppingCart,
  CircleAlert, Lightbulb, TrendingDown, ScanSearch, Filter,
  Bell, Send, PanelLeftClose, PanelLeft, Archive, Link as LinkIcon, ExternalLink,
  History, Heart, MessageCircle, Share2, Upload, MapPin,
  ThumbsUp, ThumbsDown, EyeOff, Eye, Phone, Mail
} from "lucide-react";
import * as S from './_shared';
export default function JourneyView({ ctx }) {
  const {
    ACOES_INIT,
    AcaoCard,
    AcaoDetalhe,
    AcaoModal,
    C,
    CES_COLS,
    CES_ETAPAS_NAMES,
    CES_TREND,
    CIDADES_COBERTURA,
    COOP_PLANOS_MOCK,
    CSAT_COLS,
    CSAT_ETAPAS_NAMES,
    CSAT_TREND,
    Card,
    DRIVERS_CANONICOS,
    DRIVER_TO_PILLAR,
    DistBar,
    ESCALA,
    ETAPA_DRIVER_AFFINITY,
    ETAPA_HIST,
    EtCard,
    EvaChat,
    EvaChatHistory,
    EvaInsights,
    F,
    HIST_ACOES_POR_ETAPA,
    JCFG,
    JICONS,
    LOGO,
    MESES_HIST,
    META_NPS,
    MUDANCAS_DESDE_ULTIMA_VISITA,
    MiniSparkline,
    NPSAnchor,
    PC,
    PDFExportModal,
    PER,
    PER_DEFAULT_LABELS,
    PER_OPTIONS,
    PILLAR_COLORS,
    PeriodPill,
    PeriodPillBig,
    SC,
    SHORT,
    SUCESSO_BADGES,
    SUCESSO_LEVELS,
    SYS_NPS,
    Section,
    TREND_BY_AGRUP,
    TT,
    Tag,
    ULTIMA_VISITA,
    UNIMED,
    VERBATINS_POR_ETAPA,
    Z_CX,
    Zonas,
    _META_CES_TR,
    _META_CSAT_TR,
    _META_NPS_TR,
    _SYS_CES_TR,
    _SYS_CSAT_TR,
    _SYS_NPS_TR,
    diasRest,
    etSt,
    exportPDF,
    fmtDt,
    getDriverInfo,
    getDriversForEtapa,
    getPilarOf,
    getSucessoStats,
    moe,
    pctChk,
    safeGanhoPp,
    tempoRelativo,
    todayStr
  } = S;
  const {
    DATA,
    SAUDACAO_EVA,
    acaoSel,
    acoes,
    adicionarComentario,
    agrupT,
    atualizarMensagensChatEva,
    bulkApplyEtapas,
    bulkApplyGerais,
    bulkOpen,
    bulkPct,
    busca,
    cidadesAtivas,
    compartilharPlano,
    concluirWizard,
    coopBusca,
    coopComentariosAbertos,
    coopCurtidas,
    coopDriverFilter,
    coopEtapaFilter,
    coopNovoComentario,
    coopPlanos,
    d,
    db,
    dd,
    de,
    delAcao,
    desocultarNotif,
    dj,
    driverSortMode,
    ds,
    editandoMeta,
    editandoMetaEt,
    etapaDriversFilter,
    etapaHistSel,
    etapaSel,
    evaChatAtivoId,
    evaChats,
    excluirChatEva,
    filtroCidadeAberto,
    filtroResp,
    filtroSt,
    gamificacaoOn,
    hiddenLines,
    historicoEvaVisivel,
    jorGraf,
    marcarComoLida,
    marcarTodasLidas,
    metas,
    metasCardOpen,
    metasEtapas,
    modal,
    mostrarOcultos,
    naoLidas,
    nenhumaCidade,
    notifModalFiltro,
    notifModalOpen,
    notifOpen,
    notifs,
    notifsOcultas,
    notifsVisiveis,
    novoChatEva,
    ocultarNotif,
    openPublishWizard,
    pB,
    pD,
    pE,
    pJ,
    pS,
    per,
    periodoCustom,
    periodoG,
    respDropOpen,
    segHistMode,
    segIndicador,
    selecionarChatEva,
    setAcaoSel,
    setAcoes,
    setAgrupT,
    setBulkApplyEtapas,
    setBulkApplyGerais,
    setBulkOpen,
    setBulkPct,
    setBusca,
    setCidadesAtivas,
    setConcluirWizard,
    setCoopBusca,
    setCoopComentariosAbertos,
    setCoopCurtidas,
    setCoopDriverFilter,
    setCoopEtapaFilter,
    setCoopNovoComentario,
    setCoopPlanos,
    setDriverSortMode,
    setEditandoMeta,
    setEditandoMetaEt,
    setEtapaDriversFilter,
    setEtapaHistSel,
    setEtapaSel,
    setEvaChatAtivoId,
    setEvaChats,
    setFiltroCidadeAberto,
    setFiltroResp,
    setFiltroSt,
    setGamificacaoOn,
    setHiddenLines,
    setHistoricoEvaVisivel,
    setMetaEtapa,
    setMetas,
    setMetasCardOpen,
    setMetasEtapas,
    setModal,
    setMostrarOcultos,
    setNotifFeedback,
    setNotifModalFiltro,
    setNotifModalOpen,
    setNotifOpen,
    setNotifs,
    setPB,
    setPD,
    setPE,
    setPJ,
    setPS,
    setPeriodoCustom,
    setPeriodoG,
    setPrefilledAcao,
    setRespDropOpen,
    setSegIndicador,
    setStDropOpen,
    setSucessoFiltroPeriodo,
    setSucessoModalOpen,
    setTab,
    setTipoBenefAberto,
    setTipoBeneficiario,
    setVerbatinsModal,
    stDropOpen,
    sucessoFiltroPeriodo,
    sucessoModalOpen,
    tab,
    tipoBenefAberto,
    tipoBeneficiario,
    todasCidades,
    toggleCidade,
    toggleComentarios,
    toggleCoopDriver,
    toggleCurtida,
    toggleLine,
    toggleSegHist
  } = ctx;
  return <div style={{display:"flex",flexDirection:"column",gap:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontSize:15,fontWeight:700,color:C.text,letterSpacing:"-0.02em"}}>Indicadores por etapa da jornada</div>
          <PeriodPill value={pJ} onChange={setPJ}/>
        </div>
        <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:4}}>
          {dj.etapas.map(e=><EtCard key={e.e} nome={e.e} val={e.v} vP={e.vP} dist={e.dist} distC={e.distC} sel={etapaSel===e.e} onSel={setEtapaSel}/>)}
        </div>
        {etapaSel&&(()=>{
          const et=dj.etapas.find(e=>e.e===etapaSel); if(!et) return null;
          const cfg=JCFG[et.e]; const st=etSt(et.e,et.v); const isCes=(cfg&&cfg.tipo)==="ces";
          const IconComp2=JICONS[et.e];
          return <Card style={{border:`1.5px solid ${st.color}`,padding:"14px 18px"}}>
            <div style={{display:"flex",gap:14,flexWrap:"wrap",alignItems:"flex-start"}}>
              <div style={{flex:"0 0 auto"}}>
                <div style={{display:"flex",gap:8,marginBottom:6,alignItems:"center"}}>
                  <div style={{width:30,height:30,borderRadius:9,background:isCes?C.blueBg:C.greenBg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    {IconComp2&&<IconComp2 size={16} color={isCes?C.blue:C.g700} strokeWidth={1.8}/>}
                  </div>
                  <h4 style={{margin:0,fontSize:14,fontWeight:700,letterSpacing:"-0.02em"}}>{et.e}</h4>
                  <Tag label={isCes?"CES":"CSAT"} color={isCes?C.blue:C.g700}/>
                  <button onClick={()=>setEtapaSel(null)} style={{marginLeft:6,background:"none",border:"none",cursor:"pointer",color:C.text4,display:"flex",padding:0}}><X size={15}/></button>
                </div>
                <div style={{display:"flex",gap:14,marginTop:2}}>
                  {[["Atual",`${et.v}%`,st.color],["Meta",`${(cfg&&cfg.meta)}%`,C.p500],["Ant.",`${et.vP||0}%`,C.text4],["Sist. Unimed",`${(cfg&&cfg.sys)||0}%`,C.text4]].map(([l,v,c])=>(
                    <div key={l} style={{textAlign:"center"}}><div style={{fontSize:9,color:C.text4,marginBottom:1,letterSpacing:"0.02em"}}>{l}</div><div style={{fontSize:18,fontWeight:700,color:c,letterSpacing:"-0.03em",fontFamily:F.display,lineHeight:1.1}}>{v}</div></div>
                  ))}
                </div>
                <div style={{fontSize:9,color:C.text4,marginTop:5,letterSpacing:"0.02em"}}>n={et.resp?et.resp.toLocaleString():"—"} · ±{moe(et.resp||200)}%</div>
              </div>
              {isCes&&et.dist&&<div style={{flex:1,minWidth:240}}>
                <div style={{fontSize:10,fontWeight:600,color:C.text3,textTransform:"uppercase",marginBottom:5,letterSpacing:"0.04em"}}>Distribuição CES</div>
                <DistBar dist={et.dist} tipo="ces"/>
                <div style={{marginTop:5,fontSize:10,color:C.blue,lineHeight:1.4}}>
                  <b>Top 2 Box = {et.v}%</b> (Fácil + Extr. Fácil) · meta {cfg.meta}%
                </div>
              </div>}
              {!isCes&&et.distC&&<div style={{flex:1,minWidth:240}}>
                <div style={{fontSize:10,fontWeight:600,color:C.text3,textTransform:"uppercase",marginBottom:5,letterSpacing:"0.04em"}}>Distribuição CSAT</div>
                <DistBar dist={et.distC} tipo="csat"/>
                <div style={{marginTop:5,fontSize:10,color:C.g700,lineHeight:1.4}}>
                  <b>CSAT = {et.v}%</b> (notas 4 + 5) · meta {cfg.meta}%
                </div>
              </div>}
            </div>
            {/* === DRIVERS COMPACTOS + VERBATINS + HISTORICO + CTA === */}
            {(() => {
              const driversEtapa = getDriversForEtapa(et.e, et, dj.drivers || []);
              const netSentE = (dr) => Math.round(((dr.pos||0) - (dr.neg||0)) / Math.max(1,dr.n) * 100);
              const sortedByNet = [...driversEtapa].sort((a,b)=>netSentE(b)-netSentE(a));
              const positivos = sortedByNet.filter(d => netSentE(d) > 0).slice(0, 3);
              const negativos = sortedByNet.filter(d => netSentE(d) < 0).reverse().slice(0, 3);

              // Verbatins matching ao driver — pra justificar visualmente
              // o que mais ajuda e o que mais atrapalha
              const verbatinsAll = VERBATINS_POR_ETAPA[et.e] || [];
              // 1 reclamação por driver negativo (até 2) + 1 elogio por driver positivo (até 1)
              // Total max 3, pra caber compacto na coluna
              const reclamacoes = negativos.slice(0,2).map(dr =>
                verbatinsAll.find(v => v.driver === dr.d && v.tipo === "detrator")
              ).filter(Boolean);
              const elogios = positivos.slice(0,1).map(dr =>
                verbatinsAll.find(v => v.driver === dr.d && v.tipo === "promotor")
              ).filter(Boolean);
              const verbatinsParaMostrar = [...reclamacoes, ...elogios];
              const historico = HIST_ACOES_POR_ETAPA[et.e] || [];

              // Pre-fill helpers
              const DRIVER_LABEL_TO_SLUG = {
                "Resolutividade no 1º contato": "resolutividade",
                "Agilidade no atendimento":     "agilidade",
                "Humanização no atendimento":   "atendimento_humano",
                "App facilitador":              "acesso_digital",
                "Atend. urgência e emergência": "rede_credenciada",
                "Comunicação proativa":         "comunicacao",
                "Reembolso":                    "reembolso",
                "Conciliação (Concordância)":   "cobertura",
                "Proatividade da equipe":       "prevencao",
                "Dificuldade p/ agendar":       "burocracia",
              };
              const metaEt = (cfg && cfg.meta) || 65;
              const gapEt = metaEt - et.v;

              const handleCriarPlano = () => {
                const driversNeg = negativos.map(d => DRIVER_LABEL_TO_SLUG[d.d]).filter(Boolean);
                const severidade = gapEt >= 20 ? "alta" : gapEt >= 10 ? "media" : "baixa";
                const negLabels = negativos.map(d => d.d).join(", ");
                setPrefilledAcao({
                  titulo: `Melhorar ${et.e}`,
                  desc: negLabels ? `Foco nos drivers críticos: ${negLabels}.` : `Plano de ação focado em ${et.e}.`,
                  etapa: et.e,
                  tipo: isCes ? "ces" : "csat",
                  v_meta: metaEt,
                  prio: severidade,
                  drivers: driversNeg,
                });
                setModal("new");
              };

              // Renderer compacto: nome + (pilar) + sub-text + valor
              // Variação determinística vs período anterior — hash do driver+etapa
              // Em produção: comparar netSent atual vs netSent do período anterior
              const getVarVsAnterior = (drLabel) => {
                const seed = (drLabel + et.e).split('').reduce((a,c) => a + c.charCodeAt(0), 0);
                return ((seed * 7) % 19) - 9; // -9 a +9 pp
              };

              const renderCompactRow = (dr, isNeg) => {
                const net = netSentE(dr);
                const pilar = getPilarOf(dr.d);
                const varAnt = getVarVsAnterior(dr.d);
                const varSubiu = varAnt > 0;
                return (
                  <div key={dr.d} style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, padding:"8px 11px", background:C.surface, borderRadius:6, border:`1px solid ${C.border}`}}>
                    <div style={{minWidth:0, flex:1}}>
                      <div style={{fontSize:12, fontWeight:600, color:C.text}}>
                        {dr.d}
                        {pilar && <span style={{fontSize:11, fontWeight:500, color:PILLAR_COLORS[pilar], marginLeft:5}}>({pilar})</span>}
                      </div>
                      {pilar && <div style={{fontSize:10, color:C.text4, marginTop:2}}>{pilar} · {dr.n} menções</div>}
                    </div>
                    <div style={{display:"flex", flexDirection:"column", alignItems:"flex-end", gap:1, flexShrink:0}}>
                      <div style={{fontSize:13, fontWeight:700, color:isNeg?C.red:C.green, lineHeight:1.1}}>
                        {net>0?"+":""}{net}pp
                      </div>
                      {varAnt !== 0 && (
                        <div style={{fontSize:9, fontWeight:600, color:varSubiu?C.green:C.red, display:"flex", alignItems:"center", gap:1, lineHeight:1}} title="vs período anterior">
                          {varSubiu ? <ArrowUpRight size={9}/> : <ArrowDownRight size={9}/>}
                          {varSubiu?"+":""}{varAnt}pp vs ant.
                        </div>
                      )}
                    </div>
                  </div>
                );
              };

              return (
                <div style={{marginTop:12, paddingTop:12, borderTop:`1px dashed ${C.border}`}}>

                  {/* 3 colunas: drivers + verbatins + histórico */}
                  <div style={{display:"grid", gridTemplateColumns:"minmax(0,1.1fr) minmax(0,1fr) minmax(0,1fr)", gap:10, marginBottom:10}}>

                    {/* Drivers */}
                    <div style={{padding:"10px 12px", background:C.surf3, borderRadius:9, border:`1px solid ${C.border}`}}>
                      <div style={{fontSize:10, fontWeight:700, color:C.text3, textTransform:"uppercase", letterSpacing:"0.04em", marginBottom:2, display:"flex", alignItems:"center", gap:5}}>
                        <Sparkles size={11} color={C.p500}/> por que está assim
                      </div>
                      <div style={{fontSize:9, color:C.text4, fontStyle:"italic", marginBottom:8}}>drivers que mais influenciam</div>

                      {negativos.length > 0 && (
                        <div style={{marginBottom: positivos.length ? 8 : 0}}>
                          <div style={{fontSize:9, fontWeight:700, color:C.red, textTransform:"uppercase", letterSpacing:"0.04em", marginBottom:4, display:"flex", alignItems:"center", gap:3}}>
                            <ArrowDownRight size={9}/> mais atrapalham
                          </div>
                          <div style={{display:"flex", flexDirection:"column", gap:4}}>
                            {negativos.map(dr => renderCompactRow(dr, true))}
                          </div>
                        </div>
                      )}
                      {positivos.length > 0 && (
                        <div>
                          <div style={{fontSize:9, fontWeight:700, color:C.green, textTransform:"uppercase", letterSpacing:"0.04em", marginBottom:4, display:"flex", alignItems:"center", gap:3}}>
                            <ArrowUpRight size={9}/> mais ajudam
                          </div>
                          <div style={{display:"flex", flexDirection:"column", gap:4}}>
                            {positivos.map(dr => renderCompactRow(dr, false))}
                          </div>
                        </div>
                      )}
                      {negativos.length === 0 && positivos.length === 0 && (
                        <div style={{fontSize:10, color:C.text4, fontStyle:"italic", padding:"4px 0"}}>Nenhum driver com impacto significativo nesta etapa.</div>
                      )}
                    </div>

                    {/* Verbatins */}
                    <div style={{padding:"10px 12px", background:C.surf3, borderRadius:9, border:`1px solid ${C.border}`}}>
                      <div style={{fontSize:10, fontWeight:700, color:C.text3, textTransform:"uppercase", letterSpacing:"0.04em", marginBottom:2, display:"flex", alignItems:"center", gap:5}}>
                        <MessageSquare size={11} color={C.p500}/> o que dizem
                      </div>
                      <div style={{fontSize:9, color:C.text4, fontStyle:"italic", marginBottom:8}}>principais frases que explicam cada driver — clique abaixo pra ver todas</div>
                      {verbatinsParaMostrar.length === 0 ? (
                        <div style={{fontSize:10, color:C.text4, fontStyle:"italic", padding:"4px 0"}}>Sem verbatins coletados nesta etapa.</div>
                      ) : (
                        <div style={{display:"flex", flexDirection:"column", gap:6}}>
                          {verbatinsParaMostrar.map((v,i) => {
                            const isNeg = v.tipo === "detrator";
                            const corDriver = isNeg ? C.red : v.tipo === "promotor" ? C.green : C.orange;
                            return (
                              <div key={i} style={{
                                padding:"7px 9px",
                                background:C.surface,
                                borderRadius:5,
                                borderLeft:`3px solid ${corDriver}`,
                                fontSize:10, color:C.text2, lineHeight:1.4,
                              }}>
                                {/* Driver hint — qual driver este verbatim justifica */}
                                <div style={{
                                  fontSize:8, fontWeight:700,
                                  color: corDriver,
                                  textTransform:"uppercase", letterSpacing:"0.04em",
                                  marginBottom:4,
                                  display:"flex", alignItems:"center", gap:3,
                                }}>
                                  {isNeg ? <ArrowDownRight size={9}/> : <ArrowUpRight size={9}/>}
                                  {v.driver}
                                </div>
                                "{v.texto}"
                                <div style={{fontSize:9, color:C.text4, marginTop:3, display:"flex", flexWrap:"wrap", gap:4, alignItems:"center"}}>
                                  <span style={{fontWeight:600, color:C.text3}}>{v.genero==="homem"?"Homem":"Mulher"}</span>
                                  <span>·</span>
                                  <span>{v.idade}a</span>
                                  <span>·</span>
                                  <span>{v.idade<=29?"Gen Z":v.idade<=45?"Millennial":v.idade<=61?"Gen X":v.idade<=80?"Boomer":"Silenciosa"}</span>
                                  <span>·</span>
                                  <span>{v.cidade}</span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      {/* Botão "Ver todos" — abre modal com todos os verbatins da etapa */}
                      {verbatinsAll.length > verbatinsParaMostrar.length && (
                        <button onClick={()=>setVerbatinsModal({etapa: et.e, drivers: {pos: positivos, neg: negativos}})}
                          style={{
                            display:"flex", alignItems:"center", justifyContent:"center", gap:5,
                            width:"100%", marginTop:8,
                            padding:"7px 10px",
                            background:"transparent",
                            border:`1px dashed ${C.border}`,
                            borderRadius:6,
                            fontSize:10, fontWeight:600, color:C.text3,
                            cursor:"pointer", fontFamily:"inherit",
                            transition:"all .15s",
                          }}
                          onMouseEnter={e=>{e.currentTarget.style.background=C.surface; e.currentTarget.style.borderColor=C.p500; e.currentTarget.style.color=C.p500;}}
                          onMouseLeave={e=>{e.currentTarget.style.background="transparent"; e.currentTarget.style.borderColor=C.border; e.currentTarget.style.color=C.text3;}}>
                          <MessageSquare size={10}/>
                          Ver todas as {verbatinsAll.length} frases desta etapa
                          <ArrowUpRight size={10}/>
                        </button>
                      )}
                    </div>

                    {/* Histórico de ações */}
                    <div style={{padding:"10px 12px", background:C.surf3, borderRadius:9, border:`1px solid ${C.border}`}}>
                      <div style={{fontSize:10, fontWeight:700, color:C.text3, textTransform:"uppercase", letterSpacing:"0.04em", marginBottom:2, display:"flex", alignItems:"center", gap:5}}>
                        <History size={11} color={C.p500}/> o que já tentaram
                      </div>
                      <div style={{fontSize:9, color:C.text4, fontStyle:"italic", marginBottom:8}}>planos com impacto medido</div>
                      {historico.length === 0 ? (
                        <div style={{fontSize:10, color:C.text4, fontStyle:"italic", padding:"4px 0"}}>Nenhuma ação concluída nesta etapa ainda. Será o primeiro plano de ação aqui.</div>
                      ) : (
                        <div style={{display:"flex", flexDirection:"column", gap:5}}>
                          {historico.slice(0,3).map((h, i) => (
                            <div key={i} style={{
                              padding:"7px 9px",
                              background:C.surface,
                              borderRadius:5,
                              borderLeft:`3px solid ${h.sucesso?C.green:C.text4}`,
                            }}>
                              <div style={{display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:8}}>
                                <div style={{fontSize:10, fontWeight:600, color:C.text, lineHeight:1.3, flex:1, minWidth:0}}>{h.titulo}</div>
                                <div style={{fontSize:9, fontWeight:700, flexShrink:0, color: h.sucesso?C.green:C.text4}}>
                                  {h.impacto}
                                </div>
                              </div>
                              <div style={{fontSize:8, color:C.text4, marginTop:2}}>{h.criadaEm} → {h.concluidaEm}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* CTA centralizado */}
                  <div style={{display:"flex", justifyContent:"center"}}>
                    <button onClick={handleCriarPlano}
                      style={{
                        display:"inline-flex", alignItems:"center", gap:8,
                        padding:"9px 22px 9px 14px",
                        background:`linear-gradient(135deg, ${C.g700} 0%, ${C.g600} 100%)`,
                        color:"#FFFFFF",
                        border:"none", borderRadius:999,
                        fontSize:12, fontWeight:600,
                        cursor:"pointer", fontFamily:"inherit",
                        transition:"all .15s",
                        boxShadow:`0 3px 12px ${C.g700}40, 0 1px 3px rgba(0,0,0,.1)`,
                        letterSpacing:"-0.01em",
                      }}
                      onMouseEnter={e=>{
                        e.currentTarget.style.transform = "translateY(-1px)";
                        e.currentTarget.style.boxShadow = `0 5px 16px ${C.g700}50, 0 2px 6px rgba(0,0,0,.12)`;
                      }}
                      onMouseLeave={e=>{
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = `0 3px 12px ${C.g700}40, 0 1px 3px rgba(0,0,0,.1)`;
                      }}>
                      <div style={{
                        width:22, height:22, borderRadius:"50%",
                        background:"rgba(255,255,255,.18)",
                        display:"flex", alignItems:"center", justifyContent:"center",
                        flexShrink:0,
                      }}>
                        <Plus size={13} strokeWidth={2.5}/>
                      </div>
                      <span>Criar plano de ação para <b style={{fontWeight:700}}>{et.e}</b></span>
                    </button>
                  </div>
                </div>
              );
            })()}
          </Card>;
        })()}
        <Section title="Score CSAT e CES por etapa (Top2box) com Zonas de Referência"
          action={<div style={{display:"flex",gap:8,alignItems:"center",fontSize:10,color:C.text4,flexWrap:"wrap"}}>
            {[["≥80% Excelente","#059669"],["70% Muito Bom","#16a34a"],["60% Bom","#0284c7"],["50% Atenção","#d97706"],["40% Ruim","#dc2626"],["<40% Crítico","#991b1b"]].map(([l,c])=>(
              <span key={l} style={{display:"flex",alignItems:"center",gap:3}}><div style={{width:9,height:9,borderRadius:2,background:c,opacity:.7}}/>{l}</span>
            ))}
          </div>} pad={false}>
          <div style={{padding:"0 20px 18px"}}>
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={jorGraf} margin={{top:12,bottom:28,left:0,right:16}}>
                <Zonas tipo="ces"/>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={C.border}/>
                <XAxis dataKey="name" tick={{fontSize:11,fill:C.text2,fontWeight:500}} height={32}/>
                <YAxis domain={[0,100]} tick={{fontSize:10,fill:C.text4}} tickFormatter={v=>v+"%"}/>
                <Tooltip content={({active,payload,label})=>{
                  if(!active||!(payload&&payload.length)) return null;
                  const r=jorGraf.find(x=>x.name===label);
                  return <div style={{background:"rgba(28,28,30,.95)",borderRadius:10,padding:"8px 12px",fontSize:12}}>
                    <div style={{color:"rgba(255,255,255,.5)",fontSize:11,marginBottom:4}}>{(r&&r.full)||label}</div>
                    <div style={{color:"#FFFFFF"}}>{(r&&r.tipo)==="ces"?"CES":"CSAT"}: <b style={{color:(r&&r.color)}}>{(r&&r.score)}%</b></div>
                    <div style={{color:"rgba(255,255,255,.4)",fontSize:10}}>Meta {(r&&r.meta)}% · Sist. Unimed {(r&&r.sys)}%</div>
                  </div>;
                }}/>
                <ReferenceLine y={metas.nps} stroke={C.p400} strokeDasharray="6 3" strokeWidth={1.5}/>
                <ReferenceLine y={SYS_NPS} stroke={C.g300} strokeDasharray="5 3" strokeWidth={1}/>
                <Bar dataKey="score" radius={[6,6,0,0]} maxBarSize={64}>
                  {jorGraf.map((r,i)=><Cell key={i} fill={r.color}/>)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Section>
      </div>;
}
